import { render, staticRenderFns } from "./BalancesError.vue?vue&type=template&id=25f70d18&scoped=true&"
import script from "./BalancesError.vue?vue&type=script&lang=ts&"
export * from "./BalancesError.vue?vue&type=script&lang=ts&"
import style0 from "./BalancesError.vue?vue&type=style&index=0&id=25f70d18&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f70d18",
  null
  
)

export default component.exports